




















































































import {
  apiPageConfigGetStateGroupList,
  apiPageConfigGetStateGroupResource,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defaultIndexTo } from 'vtils'
import { defineClassComponent, useApi, useLoaded, useQuery } from '@/hooks'
import { defineTvListeners } from '../utils'
import {
  makeUniGoods,
  prepareData,
  requiredDeep,
  Track,
  UniGoods,
} from '@/utils'
import { navigateTo } from '@/router'
import { XWaterfallLoad } from '@/components'

export default defineClassComponent(
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-专题',
        }))

        useLoaded(this.loading, () => this.goToCategory(0))
      }

      // 加载状态
      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        // 专题 ID
        id: string
        // 分组 ID
        groupId: string
      }>()

      // 分类索引
      categoryIndex = ref(0)

      // 筛选条件索引
      filterConditionIndex = ref(0)

      apiData = useApi(() =>
        prepareData({
          topicData: apiPageConfigGetStateGroupList({
            type: 1,
            stateGroupId: this.query.id,
          })
            .then(requiredDeep)
            .then(res => {
              this.categoryIndex.value = defaultIndexTo(
                res.stateGroupInfo.findIndex(
                  item => item.stateId === this.query.groupId,
                ),
                0,
              )
              return res
            }),
        }),
      )

      topicData = computed(() => this.apiData.data.topicData)

      // 加载列表数据
      loadData: XWaterfallLoad = ({ pageNumber }) => {
        console.log(3333)
        return apiPageConfigGetStateGroupResource({
          pageIndex: pageNumber,
          pageSize: 12,
          categoryId:
            this.topicData.value.stateGroupInfo[this.categoryIndex.value].id,
          stateIds: [
            this.topicData.value.stateGroupInfo[this.categoryIndex.value]
              .stateId,
          ],
          stateGroupId: this.query.id,
          sequenceType:
            this.filterConditionIndex.value === 1 ||
            this.filterConditionIndex.value === 3
              ? 2
              : this.filterConditionIndex.value === 2
              ? 1
              : undefined,
          sortType:
            this.filterConditionIndex.value === 1 ||
            this.filterConditionIndex.value === 2
              ? '000006'
              : this.filterConditionIndex.value === 3
              ? '000005'
              : undefined,
        }).then(res => makeUniGoods(res.list!))
      }

      // 跳到搜索
      goToSearch = () => {
        ctx.$tv.goTo(ctx.$refs.search)
      }

      // 跳到分类
      goToCategory = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.category, index)
      }

      // 跳到筛选栏
      goToFilter = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.filter, index)
      }

      // 跳到列表
      goToList = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.list, index)
      }

      // 搜索监听器
      searchListeners = defineTvListeners(({ type }) => {
        switch (type) {
          case 'up':
          case 'left':
            this.goToSearch()
            break
          case 'down':
          case 'right':
            this.goToCategory(this.categoryIndex.value)
            break
          case 'click':
            navigateTo('TvSearchIndex')
            break
          default:
            break
        }
      })

      // 分类监听器
      categoryListeners = defineTvListeners(
        ({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'focus':
              this.categoryIndex.value = index
              break
            case 'up':
              if (isFirst) {
                this.goToSearch()
              }
              break
            case 'left':
              this.goToSearch()
              break
            case 'right':
              this.goToFilter(this.filterConditionIndex.value)
              break
            case 'down':
              if (isLast) {
                this.goToCategory(-1)
              }
              break
            default:
              break
          }
        },
      )

      // 筛选栏监听器
      filterListeners = defineTvListeners(
        ({ type, index, isFirst, isLast }) => {
          switch (type) {
            case 'focus':
              this.filterConditionIndex.value = index
              break
            case 'left':
              if (isFirst) {
                this.goToCategory(this.categoryIndex.value)
              }
              break
            case 'right':
              if (isLast) {
                this.goToList(0)
              }
              break
            default:
              break
          }
        },
      )

      // 列表监听器
      listListeners = defineTvListeners<UniGoods>(
        ({ type, index, isFirst, isLast, item }) => {
          switch (type) {
            case 'up':
              if (index < 4) {
                this.goToFilter(this.filterConditionIndex.value)
              }
              break
            case 'left':
              if (isFirst) {
                this.goToCategory(this.categoryIndex.value)
              } else {
                this.goToList(index - 1)
              }
              break
            case 'right':
              if (!isLast) {
                this.goToList(index + 1)
              } else {
                this.goToList(-1)
              }
              break
            case 'click':
              navigateTo('TvGoodsIndex', {
                id: item.id,
              })
              break
            default:
              break
          }
        },
      )
    },
)
